var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: { "show-footer": false, "show-title": false },
      on: { cancel: _vm.close },
    },
    [
      _c("div", { staticClass: "suspended-modal" }, [
        _c("div", { staticClass: "suspended-modal-title" }, [
          _c("span", { staticClass: "material-icons alert-icon" }, [
            _vm._v("notification_important"),
          ]),
          _vm._v("\n            Sistem Tarafından Kısıtlandınız\n        "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "suspended-modal-description" }, [
          _c("div", { staticClass: "suspended-modal-description-content" }, [
            _vm._v(
              "\n                Ödenmeyen faturalarınız bulunduğundan dolayı sistem tarafından kısıtlandınız. Tekrar erişim sağlamak\n                için ödenmemiş faturalarınızı ödemeniz gerekmektedir.\n            "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "suspended-modal-footer" },
          [
            _c(
              "SupsisButton",
              { attrs: { primary: "" }, on: { click: _vm.close } },
              [_vm._v("Kapat")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }